import type {
  SolicitudFormData,
  SolicitudResponse,
} from "./types/solicitudInformacion";

/**
 * Envía una solicitud de información al API
 * @param data - Datos del formulario
 * @param file - Archivo adjunto (opcional)
 */
export async function postSolicitudInformacion(
  data: SolicitudFormData,
  file?: File | null,
): Promise<SolicitudResponse> {
  try {
    let response: Response;

    if (file) {
      // Si hay archivo, enviar como FormData
      const formData = new FormData();
      formData.append("nombre", data.nombre);
      formData.append("identificacion_tipo", data.identificacion_tipo);
      formData.append("identificacion_numero", data.identificacion_numero);
      formData.append("email", data.email);
      formData.append("telefono", data.telefono);
      formData.append("pais_codigo", data.pais_codigo);
      formData.append("asunto", data.asunto);
      formData.append("descripcion_solicitud", data.descripcion_solicitud);
      formData.append("adjunto", file); // El archivo real

      response = await fetch("/api/solicitud-informacion", {
        method: "POST",
        body: formData,
        // NO incluir Content-Type header, el browser lo hace automáticamente
      });
    } else {
      // Sin archivo, enviar como JSON (excluir el campo adjunto)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { adjunto, ...dataWithoutFile } = data;
      response = await fetch("/api/solicitud-informacion", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataWithoutFile),
      });
    }

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(result.message || `Error ${response.status}`);
    }

    return { success: true, message: "Solicitud enviada exitosamente" };
  } catch (error) {
    console.error("Error al enviar solicitud:", error);
    return {
      success: false,
      message: "Error al enviar la solicitud. Intente nuevamente.",
    };
  }
}
